import { FC, ReactElement, useMemo } from 'react';
import { HintTooltip, useBreakpoint } from '@brg/ui';
import styled from 'styled-components';
import { tooptipStylesWhite } from 'shared/constants/tooptipStyles';
import { LayoutConst } from 'core';
import { IContentViewItem } from '../../../../hooks/api/useContentView';
import { buildAdLegalTooltipText } from './buildAdLegalTooltipText';

const AD_LEGAL_TOOLTIP_HIDE_BREAKPOINT_PX = LayoutConst.screen.l;
const AD_LEGAL_TOOLTIP_TEXT_OFFSET_WIDE_PX = 355;
const AD_LEGAL_TOOLTIP_TEXT_OFFSET_MAC13_PX = 200;
const AD_LEGAL_TOOLTIP_Z = 10000;

const TooltipRoot = styled.span`
  position: relative;
  display: block;
  width: 100%;
  align-self: stretch;
  box-sizing: border-box;
  z-index: 0;

  & > div,
  & > div > div {
    width: 100% !important;
    max-width: none !important;
    box-sizing: border-box;
  }

  .tooltip-parent-element,
  #tooltip-parent-element {
    z-index: ${AD_LEGAL_TOOLTIP_Z} !important;
  }
`;

const TooltipHost = styled.span`
  display: contents;
`;

const hintTooltipTriggerStyle = (customStyle: Record<string, unknown>) => {
    const {
        maxWidth: _mw,
        whiteSpace: _ws,
        wordBreak: _wb,
        zIndex: _zi,
        width: _w,
        minWidth: _minW,
        ...rest
    } = customStyle;
    return rest;
};

type AdLegalHintTooltipProps = {
    adItem: IContentViewItem;
    children: ReactElement;
    onWhiteBg?: boolean;
    customStyle?: Record<string, unknown>;
};

export const AdLegalHintTooltip: FC<AdLegalHintTooltipProps> = ({
    adItem,
    children,
    onWhiteBg = true,
    customStyle = tooptipStylesWhite,
}) => {
    const text = buildAdLegalTooltipText(adItem);
    const hideTooltip = useBreakpoint(AD_LEGAL_TOOLTIP_HIDE_BREAKPOINT_PX);
    const isMac13OrBelow = useBreakpoint(LayoutConst.screen.mac13);
    const isAtMostL = useBreakpoint(LayoutConst.screen.l);
    const textOffset = isMac13OrBelow && !isAtMostL
        ? `${AD_LEGAL_TOOLTIP_TEXT_OFFSET_MAC13_PX}px`
        : `${AD_LEGAL_TOOLTIP_TEXT_OFFSET_WIDE_PX}px`;
    const triggerStyle = useMemo(
        () => hintTooltipTriggerStyle(customStyle),
        [customStyle],
    );

    if (!text || hideTooltip) {
        return children;
    }

    return (
        <TooltipRoot>
            <HintTooltip
                text={text}
                noArrow
                onWhiteBg={onWhiteBg}
                positionY="top"
                z={AD_LEGAL_TOOLTIP_Z}
                textOffset={textOffset}
                offsetYText="80px"
                customStyle={triggerStyle}
            >
                <TooltipHost>{children}</TooltipHost>
            </HintTooltip>
        </TooltipRoot>
    );
};
import { FC, ReactElement, useMemo } from 'react';
import { HintTooltip, useBreakpoint } from '@brg/ui';
import styled from 'styled-components';
import { tooptipStylesWhite } from 'shared/constants/tooptipStyles';
import { LayoutConst } from 'core';
import { IContentViewItem } from '../../../../hooks/api/useContentView';
import { buildAdLegalTooltipText } from './buildAdLegalTooltipText';

const AD_LEGAL_TOOLTIP_HIDE_BREAKPOINT_PX = LayoutConst.screen.l;
const AD_LEGAL_TOOLTIP_TEXT_OFFSET_WIDE_PX = 355;
const AD_LEGAL_TOOLTIP_TEXT_OFFSET_MAC13_PX = 200;
const AD_LEGAL_TOOLTIP_Z = 10000;

const TooltipRoot = styled.span`
  position: relative;
  display: block;
  width: 100%;
  align-self: stretch;
  box-sizing: border-box;
  z-index: 0;

  & > div,
  & > div > div {
    width: 100% !important;
    max-width: none !important;
    box-sizing: border-box;
  }

  .tooltip-parent-element,
  #tooltip-parent-element {
    z-index: ${AD_LEGAL_TOOLTIP_Z} !important;
  }
`;

const TooltipHost = styled.span`
  display: contents;
`;

const hintTooltipTriggerStyle = (customStyle: Record<string, unknown>) => {
    const {
        maxWidth: _mw,
        whiteSpace: _ws,
        wordBreak: _wb,
        zIndex: _zi,
        width: _w,
        minWidth: _minW,
        ...rest
    } = customStyle;
    return rest;
};

type AdLegalHintTooltipProps = {
    adItem: IContentViewItem;
    children: ReactElement;
    onWhiteBg?: boolean;
    customStyle?: Record<string, unknown>;
};

export const AdLegalHintTooltip: FC<AdLegalHintTooltipProps> = ({
    adItem,
    children,
    onWhiteBg = true,
    customStyle = tooptipStylesWhite,
}) => {
    const text = buildAdLegalTooltipText(adItem);
    const hideTooltip = useBreakpoint(AD_LEGAL_TOOLTIP_HIDE_BREAKPOINT_PX);
    const isMac13OrBelow = useBreakpoint(LayoutConst.screen.mac13);
    const isAtMostL = useBreakpoint(LayoutConst.screen.l);
    const textOffset = isMac13OrBelow && !isAtMostL
        ? `${AD_LEGAL_TOOLTIP_TEXT_OFFSET_MAC13_PX}px`
        : `${AD_LEGAL_TOOLTIP_TEXT_OFFSET_WIDE_PX}px`;
    const triggerStyle = useMemo(
        () => hintTooltipTriggerStyle(customStyle),
        [customStyle],
    );

    if (!text || hideTooltip) {
        return children;
    }

    return (
        <TooltipRoot>
            <HintTooltip
                text={text}
                noArrow
                onWhiteBg={onWhiteBg}
                positionY="top"
                z={AD_LEGAL_TOOLTIP_Z}
                textOffset={textOffset}
                offsetYText="80px"
                customStyle={triggerStyle}
            >
                <TooltipHost>{children}</TooltipHost>
            </HintTooltip>
        </TooltipRoot>
    );
};
